export default () => {
  const banner = document.querySelector('.top-banner-offers');

  if(!(window.location.host.split('.')[2] == 'sk') && window.location.pathname === '/') {
    window.addEventListener('load', function() {
      let controller = new AbortController();
      if(window.innerWidth >1024)
        setTimeout(()=> loadBanner(),1000);
    });
  }


  function loadBanner(){
    document.body.click();
    banner.style.display ='';
    // $(".top-banner-offers").slideDown();
    document.body.click();
  }
}
